import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { convertUtcDate } from '../components/Common/cleanDates';

import {
    REQUEST_PUT_AWAY,
    FETCH_PUT_AWAY_SUCCESS,
    FETCH_PUT_AWAY_FAILURE,
    RESET_CURRENT_PUT_AWAY,
    REQUEST_CREATING_PUT_AWAY,
    CREATE_PUT_AWAY_SUCCESS,
    CREATE_PUT_AWAY_FAILURE,
    SELECT_PUT_AWAY,
    REQUEST_PUT_AWAY_DETAIL,
    FETCH_PUT_AWAY_DETAIL_SUCCESS,
    FETCH_PUT_AWAY_DETAIL_FAILURE,
    REQUEST_EDITING_PUT_AWAY,
    EDIT_PUT_AWAY_SUCCESS,
    EDIT_PUT_AWAY_FAILURE,
    REQUEST_BIN_LIST_DETAIL,
    FETCH_BIN_LIST_DETAIL_SUCCESS,
    FETCH_BIN_LIST_DETAIL_FAILURE,
    REQUEST_CREATING_BINS,
    CREATE_BINS_SUCCESS,
    CREATE_BINS_FAILURE,
    SELECT_WAREHOUSE_RECEIVE,
    RESET_CURRENT_WAREHOUSE_RECEIVE,
    AUTO_PUTAWAY,
    AUTO_PUTAWAY_SUCCESS,
    AUTO_PUTAWAY_FAILURE
} from './type'

import {
  PUT_AWAY_URL,
  BINS_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

// ScrapRecords Actions

export function fetchPutAway() {
    return dispatch => {
        dispatch({ type: REQUEST_PUT_AWAY });
        return axios.get(PUT_AWAY_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPutAwaySuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchPutAwayFailure(err));                             
              }
            });
    }
}

export function fetchPutAwaySuccess(PutAway) {
    return {
        type: FETCH_PUT_AWAY_SUCCESS,
        payload: PutAway
    };
}

export function fetchPutAwayFailure(error) {
    return {
        type: FETCH_PUT_AWAY_FAILURE,
        payload: error
    };
}
export function resetCurrentPutAway() {
    return {
        type: RESET_CURRENT_PUT_AWAY
    }
}

export function selectPutAway(putAway) {
    return {
        type: SELECT_PUT_AWAY,
        payload: putAway
    };
}

export function fetchPutAwayDetail(warehousePutAway_id) {
    return dispatch => {
        dispatch({ type: REQUEST_PUT_AWAY_DETAIL });
        return axios.get(PUT_AWAY_URL + warehousePutAway_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPutAwayDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchPutAwayDetailFailure(err));                             
              }
            });
    }
}

export function fetchPutAwayDetailSuccess(putAwayDetail) {
    return {
        type: FETCH_PUT_AWAY_DETAIL_SUCCESS,
        payload: putAwayDetail
    };
}

export function fetchPutAwayDetailFailure(error) {
    return {
        type: FETCH_PUT_AWAY_DETAIL_FAILURE,
        payload: error
    };
}


export function createPutAway({
  CreateTime,
  UpdateTime
  },
  {
  PONum,
  WarehouseReceiveNum,
  Create_Username,
  Modify_Username,
  PostingDate,
  Note,
  Owner,
  Warehouse_id,
  WarehouseReceive
},Warehouse_PutAway_Line) {
    if(WarehouseReceive){
      PONum = WarehouseReceive.PONum;
      WarehouseReceiveNum = WarehouseReceive.WarehouseReceiveNum;
      Owner = WarehouseReceive.Owner;
      Warehouse_id = WarehouseReceive.Warehouse_id;
    }
    CreateTime = (CreateTime) ? convertUtcDate(CreateTime) : '';
    UpdateTime = (UpdateTime) ? convertUtcDate(UpdateTime) : '';
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PUT_AWAY });
        axios.post(PUT_AWAY_URL,
            {
              PONum,
              WarehouseReceiveNum,
              Create_Username,
              Modify_Username,
              PostingDate,
              CreateTime,
              UpdateTime,
              Note,
              Owner,
              Warehouse_id,
              Warehouse_PutAway_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createPutAwaySuccess());
              browserHistory.push('/putAway');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createPutAwayFailure(err));                             
              }
            });
    }
}

export function createPutAwaySuccess() {
    return {
        type: CREATE_PUT_AWAY_SUCCESS
    }
}

export function createPutAwayFailure(error) {
    return {
        type: CREATE_PUT_AWAY_FAILURE,
        payload: error
    }
}

export function editPutAway({
  CreateTime,
  UpdateTime
  },
  {
  PONum,
  WarehouseReceiveNum,
  Create_Username,
  Modify_Username,
  PostingDate,
  Note,
  Owner,
  Warehouse_id
}, Warehouse_PutAway_Line, WarehousePutAway_id) {
    CreateTime = (CreateTime) ? convertUtcDate(CreateTime) : '';
    UpdateTime = (UpdateTime) ? convertUtcDate(UpdateTime) : '';
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_PUT_AWAY });
        axios.put(PUT_AWAY_URL + WarehousePutAway_id,
          {
            PONum,
            WarehouseReceiveNum,
            Create_Username,
            Modify_Username,
            PostingDate,
            CreateTime,
            UpdateTime,
            Note,
            Owner,
            Warehouse_id,
            Warehouse_PutAway_Line
          },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editPutAwaySuccess());
              browserHistory.push('/putAway');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editPutAwayFailure(err));                             
              }
            });
    }
}

export function editPutAwaySuccess() {
    return {
        type: EDIT_PUT_AWAY_SUCCESS
    }
}

export function editPutAwayFailure(error) {
    return {
        type: EDIT_PUT_AWAY_FAILURE,
        payload: error
    }
}


export function fetchBinList(warehouseReceive_id) {
    return dispatch => {
          dispatch({ type: REQUEST_BIN_LIST_DETAIL });
        return axios.get(PUT_AWAY_URL + 'detail/'+ warehouseReceive_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchBinListSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchBinListFailure(err));                             
              }
            });
    }
}

export function fetchBinListSuccess(binList) {
    return {
        type: FETCH_BIN_LIST_DETAIL_SUCCESS,
        payload: binList
    };
}

export function fetchBinListFailure(error) {
    return {
        type: FETCH_BIN_LIST_DETAIL_FAILURE,
        payload: error
    };
}



export function createBins(
  Product_id,
  WarehouseReceiveLine_id,
  error,
  BinList
) {
  return dispatch => {
      dispatch({ type: REQUEST_CREATING_BINS });
      axios.post(BINS_URL + 'auto/',
          {
            Product_id,
            WarehouseReceiveLine_id,
            error,
            BinList
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(createBinsSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(createBinsFailure(err));                           
            }
          });
  }
}

export function createBinsSuccess(response) {
    return {
        type: CREATE_BINS_SUCCESS,
        payload: response
    }
}

export function createBinsFailure(error) {
    return {
        type: CREATE_BINS_FAILURE,
        payload: error
    }
}

export function selectWarehouseReceive(Product_id, WarehouseReceiveLine_id, error, BinList) {
    let currentWarehouseReceive = new Object();
    currentWarehouseReceive['Product_id'] = Product_id;
    currentWarehouseReceive['WarehouseReceiveLine_id'] = WarehouseReceiveLine_id;
    currentWarehouseReceive['error'] = error;
    currentWarehouseReceive['BinList'] = BinList;
    return {
          type: SELECT_WAREHOUSE_RECEIVE,
        payload: currentWarehouseReceive
    };
}


export function resetCurrentWarehouseReceive() {
    return {
        type: RESET_CURRENT_WAREHOUSE_RECEIVE
    }
}

export function fetchBinListFromZone(WarehouseZone_id, {WarehouseReceiveLine_id, error, BinList}) {
    return dispatch => {
          dispatch({ type: REQUEST_BIN_LIST_DETAIL });
        return axios.post(BINS_URL + 'relocate/',
            {
              WarehouseZone_id,
              WarehouseReceiveLine_id,
              error,
              BinList
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchBinListFromZoneSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchBinListFromZoneFailure(err));                             
              }
            });
    }
}

export function fetchBinListFromZoneSuccess(binList) {
    return {
        type: FETCH_BIN_LIST_DETAIL_SUCCESS,
        payload: binList
    };
}

export function fetchBinListFromZoneFailure(error) {
    return {
        type: FETCH_BIN_LIST_DETAIL_FAILURE,
        payload: error
    };
}

export function autoPutaway(Warehouse_Receives) {
  return dispatch => {
    dispatch({type: AUTO_PUTAWAY});
    return axios.post(PUT_AWAY_URL + 'auto/',
    {
      Warehouse_Receives
    },
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(autoPutawaySuccess(response));
      browserHistory.push('/inventories/receiveHistory');
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(autoPutawayFailure(err));                     
      }
    });
  }
}

export function autoPutawaySuccess(files) {
  return {
    type: AUTO_PUTAWAY_SUCCESS,
    payload: files
  }
}

export function autoPutawayFailure(error) {
  return {
    type: AUTO_PUTAWAY_FAILURE,
    payload: error
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/putAway_actions.jsx